// extracted by mini-css-extract-plugin
export default {"generalBody":"GeneralBodyContainer_generalBody__AsE7K","generalBody-subcont":"GeneralBodyContainer_generalBody-subcont__Tqj3t"};